// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Contact_contactSection__urKI1 {
  display: flex;
  justify-content: center;
  background-color: var(--color-white);
  margin: 2rem 5rem 8rem 5rem;
  padding-bottom: 4rem;
  gap: 10rem;
}
@media only screen and (max-width: 1000px) {
  .Contact_contactSection__urKI1 {
    gap: 0;
    margin: 2rem 2rem 8rem 2rem;
  }
}
@media only screen and (max-width: 800px) {
  .Contact_contactSection__urKI1 {
    display: grid;
    grid-template-columns: 1fr;
    justify-content: center;
    justify-items: center;
    margin: 2rem 5rem 8rem 5rem;
  }
}
@media only screen and (max-width: 550px) {
  .Contact_contactSection__urKI1 {
    margin: 2rem 0 8rem 0;
  }
}

.Contact_contact__Gmq22 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
}
@media only screen and (max-width: 450px) {
  .Contact_contact__Gmq22 {
    grid-template-columns: 1fr;
    align-items: center;
  }
}
.Contact_contact__mode__WbFw0 {
  padding: 4rem 3rem 4rem 3rem;
  align-content: center;
  max-width: 31rem;
}
@media only screen and (max-width: 900px) {
  .Contact_contact__mode__WbFw0 {
    padding: 4rem 1rem 2rem 0;
    align-content: center;
    max-width: 25rem;
  }
}
@media only screen and (max-width: 800px) {
  .Contact_contact__mode__WbFw0 {
    padding: 4rem 4rem 4rem 4rem;
    align-content: center;
    max-width: 31rem;
  }
  .Contact_contact__mode__WbFw0:hover {
    box-sizing: border-box;
    background-color: var(--color-light);
    border-radius: 2rem;
    padding: 1rem 1rem;
  }
}
.Contact_contact__mode__WbFw0:hover {
  box-sizing: border-box;
  background-color: var(--color-light);
  border-radius: 2rem;
  padding: 2rem 2rem;
}

.Contact_form__luwx- {
  display: flex;
  flex-direction: column;
  padding: 5rem 3rem 3rem 3rem;
  margin: 8rem 0;
  justify-content: center;
  align-items: center;
  max-width: 45rem;
  box-shadow: 0px 6px 60px 0px rgba(0, 0, 0, 0.08);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/LandingPage/Contact.module.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,uBAAA;EACA,oCAAA;EACA,2BAAA;EACA,oBAAA;EACA,UAAA;AAFJ;AAII;EARJ;IASQ,MAAA;IACA,2BAAA;EADN;AACF;AAGI;EAbJ;IAcO,aAAA;IACA,0BAAA;IACA,uBAAA;IACA,qBAAA;IACA,2BAAA;EAAL;AACF;AAEI;EArBJ;IAsBO,qBAAA;EACL;AACF;;AAIA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAII;EANJ;IAOQ,0BAAA;IACA,mBAAA;EADN;AACF;AAII;EACI,4BAAA;EACA,qBAAA;EACA,gBAAA;AAFR;AAIQ;EALJ;IAMQ,yBAAA;IACA,qBAAA;IACA,gBAAA;EADV;AACF;AAEQ;EAVJ;IAWQ,4BAAA;IACA,qBAAA;IACA,gBAAA;EACV;EACU;IACI,sBAAA;IACA,oCAAA;IACA,mBAAA;IACA,kBAAA;EACd;AACF;AAEQ;EACI,sBAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;AAAZ;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gDAAA;AAHJ","sourcesContent":["@import '../variables/breakpoints';\n\n\n.contactSection {\n    display: flex;\n    justify-content: center;\n    background-color: var(--color-white);\n    margin: 2rem 5rem 8rem 5rem;\n    padding-bottom: 4rem;   \n    gap: 10rem;\n\n    @media only screen and (max-width: 1000px) {\n        gap: 0;\n        margin: 2rem 2rem 8rem 2rem;\n    }\n\n    @media only screen and (max-width: 800px) {\n       display: grid;\n       grid-template-columns: 1fr;      \n       justify-content: center;\n       justify-items: center;      \n       margin: 2rem 5rem 8rem 5rem;\n       \n    }\n    @media only screen and (max-width: 550px) {        \n       margin: 2rem 0 8rem 0;\n       \n    }\n\n}\n\n.contact {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    align-items: center;\n    // gap: 2rem;\n\n    @media only screen and (max-width: 450px) {\n        grid-template-columns: 1fr;\n        align-items: center;        \n    }\n\n\n    &__mode {\n        padding: 4rem 3rem 4rem 3rem;\n        align-content: center;\n        max-width: 31rem;\n\n        @media only screen and (max-width: 900px) {\n            padding: 4rem 1rem 2rem 0;\n            align-content: center;\n            max-width: 25rem;\n        }\n        @media only screen and (max-width: 800px) {\n            padding: 4rem 4rem 4rem 4rem;\n            align-content: center;\n            max-width: 31rem;\n\n            &:hover {\n                box-sizing: border-box;\n                background-color: var(--color-light);\n                border-radius: 2rem;\n                padding: 1rem 1rem;\n            }\n        }\n\n        &:hover {\n            box-sizing: border-box;\n            background-color: var(--color-light);\n            border-radius: 2rem;\n            padding: 2rem 2rem;\n        }\n    }\n\n}\n\n.form {\n    display: flex;\n    flex-direction: column;\n    padding: 5rem 3rem 3rem 3rem;\n    margin: 8rem 0;\n    justify-content: center;\n    align-items: center;\n    max-width: 45rem;   \n    box-shadow: 0px 6px 60px 0px rgba(0, 0, 0, 0.08);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contactSection": `Contact_contactSection__urKI1`,
	"contact": `Contact_contact__Gmq22`,
	"contact__mode": `Contact_contact__mode__WbFw0`,
	"form": `Contact_form__luwx-`
};
export default ___CSS_LOADER_EXPORT___;
